import popsss from 'lib/popsss';

import { setErrors } from 'lib/widget/actions';
import { updateURLSearchParams } from 'lib/updateURLSearchParams';

export const CRUD_CREATE_OPEN = 'CRUD_CREATE_OPEN';
export const CRUD_CREATE_CANCEL = 'CRUD_CREATE_CANCEL';

export const openCreate = (params) => ({ type: CRUD_CREATE_OPEN, params });
export const cancelCreate = () => ({ type: CRUD_CREATE_CANCEL });

export const CRUD_CREATE_SUBMIT = 'CRUD_CREATE_SUBMIT';
export const CRUD_CREATE_SUCCESS = 'CRUD_CREATE_SUCCESS';
export const CRUD_CREATE_FAIL = 'CRUD_CREATE_FAIL';

export const SAVE_CRUD_ROWS = 'SAVE_CRUD_ROWS';
export const UPDATE_OFFSET = 'UPDATE_OFFSET';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATING_CRUD = 'UPDATING_CRUD';
export const UPDATE_CRUD_FINISHED = 'UPDATE_CRUD_FINISHED';
export const SELECT_ITEM = 'SELECT_ITEM';
export const DESELECT_ITEM = 'DESELECT_ITEM';
export const SELECT_ALL = 'SELECT_ALL';
export const DESELECT_ALL = 'DESELECT_ALL';
export const SELECT_VISIBLE = 'SELECT_VISIBLE';

export const CRUD_ACTION_FINISHED = 'CRUD_ACTION_FINISHED';
export const CRUD_CLEAR_LINES = 'CRUD_CLEAR_LINES';

export function submitCreate(onSuccess) {
  return (dispatch, getState) => {
    dispatch({ type: CRUD_CREATE_SUBMIT });

    const { widget, crud } = getState();
    const widgetsData = widget.widgetsData;
    const values = Object.keys(widgetsData).reduce((prevVal, elem) => {
      prevVal[elem] = widgetsData[elem]['value'];
      return prevVal;
    }, {});

    popsss
      .postFormData('./create', {
        values: JSON.stringify(values),
        params: JSON.stringify(crud.params),
      })
      .done((result) => {
        if (result.error) {
          dispatch({ type: CRUD_CREATE_FAIL, errors: {} });
          popsss.alertError(result.error);
        } else if (result.errors) {
          dispatch({ type: CRUD_CREATE_FAIL, errors: result.errors });
          dispatch(setErrors(result.errors));
        } else {
          dispatch({ type: CRUD_CREATE_SUCCESS, id: result.context_id });
          if (onSuccess) {
            onSuccess(result);
          }
        }
      })
      .fail(() => dispatch({ type: CRUD_CREATE_FAIL, errors: {} }));
  };
}

export const fetchTabulation = (params) => {
  return (dispatch, getState) => {
    const state = getState().crud.tableData;
    const offset = Object.keys(state.lines).length;
    dispatch({ type: UPDATING_CRUD });

    popsss.getJSON('./tabulation', { offset, ...params }).done((result) => {
      dispatch({ type: SAVE_CRUD_ROWS, lines: result.lines });
      if (result.lines.length !== 0) {
        // Fetch more if we haven't reached the end of the results
        dispatch(fetchTabulation(params));
      } else {
        dispatch({ type: UPDATE_CRUD_FINISHED });
      }
    });
  };
};

export const refreshTabulation = (params) => (dispatch) => {
  dispatch({ type: CRUD_CLEAR_LINES });
  dispatch(fetchTabulation(params));
};

export const updateOffset = (offset) => ({
  type: UPDATE_OFFSET,
  offset,
});

export const updateFilter = (column, type, value, options) => (dispatch) => {
  dispatch(updateOffset(0)); // Reset the offset, to the begining
  const additionalColumns = options ? options.additionalColumns : undefined;
  dispatch({
    type: UPDATE_FILTER,
    column,
    filterType: type,
    value,
    additionalColumns,
  });

  if (options && options.persist) {
    updateURLSearchParams(column, value);
  }
};

export const select = (id) => ({
  type: SELECT_ITEM,
  id,
});
export const deselect = (id) => ({
  type: DESELECT_ITEM,
  id,
});

export const selectAll = () => ({ type: SELECT_ALL });
export const deselectAll = () => ({ type: DESELECT_ALL });
export const selectVisible = (offset) => ({
  type: SELECT_VISIBLE,
  offset,
});
